
import { computed, defineComponent, watch } from 'vue';
import postsStore from '@/store/posts';
import router from '@/router';

export default defineComponent({
    name: 'post',

    setup() {
        const { id } = router.currentRoute.value.params;
        const { loading, selectedPost, fetchSelectedPost } = postsStore();

        fetchSelectedPost(String(id));

        watch(selectedPost, () => {
            if (selectedPost.value.title)
                document.title = `${selectedPost.value.title} | Vue3 Blog`;
        });

        return { loading, selectedPost: computed(() => selectedPost.value) };
    },
});
